import { useState } from 'react'
import upIcon from './assets/images/up.svg'
import downIcon from './assets/images/down.svg'
import c from './assets/sass/accordion.module.scss'

export const Accordion = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className={c.component}>
            <div className={c.header} onClick={() => setIsOpen(!isOpen)}>
                <div className={c.question}>{question}</div>
                <div className={c.icon}>
                    <img src={isOpen ? upIcon : downIcon} alt="" />
                </div>
            </div>
            {isOpen && <div className={c.answer}>{answer}</div>}
        </div>
    )
}
